/**
 * a loading Animation to show something is happening
 * the animation is based on css-animation
 * @see /oyc-content/themes/oyCeme/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/scss/_loader.scss
 * @type Object
 */
oyc.Loader = {
  loader: this.loader || {},
  noAutoLoad: true,
  classes: {
    active: 'active'
  },
  markup: '<div class="oyc-loader"><div class="spinner"><div class="bounce"></div><div class="bounce b-1"></div><div class="bounce b-2"></div></div></div>',
  /**
   * @param {jQuery|string} container string or jQuery object where the loader should be put inside (appended)
   * @returns {oyc.Loader}
   */
  init: function (container) {
    let idx = 'body';
    oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Css/oyc-loader.css');
    switch (typeof container) {
      case 'undefined':
        container = $(idx);
        break;
      case 'string':
        idx = container;
        container = $(container);
        break;
      default:
        idx = container.selector;
    }

    if (0 < container.length) {
      if (typeof this.loader[idx] === 'undefined') {
        this.loader[idx] = $(this.markup).clone();
        container.append(this.loader[idx]);
      }
      return this;
    } else {
      console.log('container for loading animation not found.');
    }
  },
  /**
   * adding a class indicating the loader to show up
   * @param {string} idx
   * @returns {undefined}
   */
  show: function (idx) {
    idx = idx || 'body';
    if (!(idx in this.loader)) {
      this.init(idx);
    }
    const stack = new Error().stack.split('\n')[2].trim();
    console.log('Loader.show() via', stack);
    this.loader[idx].addClass(this.classes.active);
  },
  /**
   * adding a class indicating the loader to show up
   * @param {string} idx
   * @param {boolean} remove
   * @returns {undefined}
   */
  hide: function (idx, remove) {
    idx = idx || 'body';

    if (this.loader[idx]) {
      this.loader[idx].removeClass(this.classes.active);
      if (typeof remove !== 'undefined' && remove === true) {
        setTimeout(this.remove.bind(this), 300, idx);
      }
    }
  },
  /**
   * removing loader from the DOM tree
   * @param {string} idx
   * @returns {undefined}
   */
  remove: function (idx) {
    idx = idx || 'body';
    this.loader[idx].remove();
  }
};
